module.exports = __webpack_public_path__ + "static/img/logo_mobidata.360ba37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_mobidata.png
// module id = +iWs
// module chunks = 4